import { conversationStateValues } from '@rsos/reduxDataStore/src/features/conversations/conversations.typings';
import {
  getConversationID,
  getHasConversationBeenInitiated,
  getIsConversationEnded,
} from '@rsos/reduxDataStore/src/features/conversations/utils';

// exists as any, remove when actually typed
interface mockTF911Conversation {
  data?: {
    conversation_id: string;
    custom?: {
      STATUS: string;
    };
  };
}

export const getSelectedConversationID = (
  conversation?: conversationStateValues,
  tf911conversation?: mockTF911Conversation,
) => {
  if (conversation) {
    return getConversationID(conversation) || '';
  }

  return tf911conversation?.data?.conversation_id || '';
};

export const getIsSelectedChatActive = (
  conversation?: conversationStateValues,
  tf911conversation?: mockTF911Conversation,
) => {
  if (conversation) {
    const isConversationOngoing =
      getHasConversationBeenInitiated(conversation) &&
      !getIsConversationEnded(conversation);

    return isConversationOngoing;
  }

  const isTF911ConversationOngoing = Boolean(
    tf911conversation?.data?.conversation_id &&
      tf911conversation?.data?.custom?.STATUS !== 'CONVERSATION_ENDED',
  );

  return isTF911ConversationOngoing;
};
